import { DeveloperCredentials } from '../authentication/credentials';
import { EntityStatus } from '../portal/account-console-test/subscription-information/subscription-information.component';

export class Instance {
    InstanceKey: string;
    Description: string;
    //FrontEndUrl: string;
    Disabled: boolean;
    Origin: string;
    Tags: string;
    UnderMaintenance: boolean;
    Activated: boolean;
    VerificationCode: number;
    SecurityValue: string;
    ParentAccount: string;
    PartnerCode: string;
    CreatorAccountEmail: string;
    CreatorAccountUserName: string;

    constructor() {}
}

export class CreateInstanceStruct extends DeveloperCredentials {
    instanceKey = '';
    description = '';
    forInternalDeveloper = false; // per associare il dominio interno microarea per le istanze create dal Polpen
    domainId = '';
    //frontendurl = '';
    origin = '';
    alsoDisabled = false;
    partnerCode = '';
    accountName = '';
    // verticals : string[];
}

export class SubWInst {
    description = '';
    instanceKey = '';
    securityValue = '';
    //frontendurl = '';
}

export namespace InstanceType {
    export const CLOUD = 'cloud';
    export const ONPREMISES = 'onPremise';
}

export class MpIstance {
    Activated: boolean;
    CreationDate: Date;
    Demo: boolean;
    Description: string;
    Disabled: boolean;
    InstanceKey: string;
    Notes: string;
    Origin: string;
    ParentAccount: string;
    PartnerCode: string;
    PendingDate: Date;
    SecurityValue: string;
    Status: EntityStatus;
    Tags: string[];
    UnderMaintenance: boolean;
    VerificationCode: string;
    Verticals: string[];
}

export class InstanceVersionInfo {
    InstanceKey: string;
    Tags: string[] = [];
    Version: string;
}

export enum SnapshotType {
    UNKNOWN = 'Unknown',
    DEFAULT = 'Default',
    HIGHAVAILABILITY = 'HighAvailability',
    CANDIDATE = 'Candidate',
}

export class InstSnapVersInfo {
    public InstanceKey: string = '';
    public IKDescription: string = '';
    public SnapshotId: string = '';
    public Description: string = '';
    public SnapshotType: string = '';
    public Version: string = '';
}
